import { extendTheme } from '@chakra-ui/react';
import { globalStyles } from './styles';
import { fonts } from './foundations/fonts';
import { breakpoints } from './foundations/breakpoints';
import { buttonStyles } from './components/button';
import { badgeStyles } from './components/badge';
import { linkStyles } from './components/link';
import { drawerStyles } from './components/drawer';
import { CardComponent } from './additions/card/Card';
import { CardBodyComponent } from './additions/card/CardBody';
import { CardHeaderComponent } from './additions/card/CardHeader';
import { MainPanelComponent } from './additions/layout/MainPanel';
import { PanelContentComponent } from './additions/layout/PanelContent';
import { PanelContainerComponent } from './additions/layout/PanelContainer';
import { headingStyles } from './components/heading';
import { MultiSelect } from './components/multiselect';
import { formControlInput } from './components/formControl';
import { FloatinLabelInputVariant } from './components/FloatinLabelInput';

export default extendTheme(
  {
    config: {
      initialColorMode: 'light',
      useSystemColorMode: false,
    },
    formControlInput,
  },
  { breakpoints }, // Breakpoints
  globalStyles,
  fonts, // Global styles
  buttonStyles, // Button styles
  headingStyles, // Heading style
  badgeStyles, // Badge styles
  linkStyles, // Link styles
  drawerStyles, // Sidebar variant for Chakra's drawer
  CardComponent, // Card component
  CardBodyComponent, // Card Body component
  CardHeaderComponent, // Card Header component
  MainPanelComponent, // Main Panel component
  PanelContentComponent, // Panel Content component
  PanelContainerComponent, // Panel Container component
  MultiSelect, // MultiSelect component
  FloatinLabelInputVariant
);
